import { createFileRoute } from '@tanstack/react-router'
import { UsageLayout } from '@/components/layout/usage'

export const Route = createFileRoute('/_auth/usage/')({
  component: UsagePage,
  head: () => ({
    meta: [{ name: 'SUL AI', content: 'SUL AI' }, { title: 'SUL AI | Usage' }],
  }),
})

function UsagePage() {
  return <UsageLayout />
}
